export default "__VITE_ASSET__ClZw10cj__"